import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Footer() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  return (
    <footer className="bg-espresso text-ivory mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-serif text-4xl mb-4">KIMA</div>
          <p className="text-taupe text-sm leading-relaxed">Un boutique digitale delle unghie che ricorda ogni cliente e la accompagna nella sua identità.</p>
        </div>
        <div>
          <div className="kima-overline text-taupe mb-4">Esplora</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/servizi" className="hover:text-burgundy transition-colors">Servizi</Link></li>
            <li><Link to="/kima-match" className="hover:text-burgundy transition-colors">KIMA Match</Link></li>
            <li><Link to="/galleria" className="hover:text-burgundy transition-colors">Galleria</Link></li>
            <li><Link to="/nail-artists" className="hover:text-burgundy transition-colors">Nail Artists</Link></li>
          </ul>
        </div>
        <div>
          <div className="kima-overline text-taupe mb-4">Contatti</div>
          <ul className="space-y-2 text-sm text-ivory/90">
            <li>{s.address}</li>
            <li>{s.phone}</li>
            <li>{s.email}</li>
          </ul>
        </div>
        <div>
          <div className="kima-overline text-taupe mb-4">Orari</div>
          <ul className="space-y-1 text-sm text-ivory/90">
            <li>Mar–Sab · 11:30–20:00</li>
            <li>Dom & Lun · Chiuso</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ivory/10 py-6 text-center text-xs text-taupe">© {new Date().getFullYear()} KIMA Nails · Sassari · Bozza legale soggetta a revisione professionale</div>
    </footer>
  );
}
